import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as SolarImage } from "../../assets/images/solarSystemImage.svg";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import classes from "./SignInPage.module.scss";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useSnackbar } from "notistack";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import ForgotPassOne from "./ForgotPassOne";
import { BsGlobe2 } from "react-icons/bs";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import "./test.css";

const SignInPage = ({
  changeHandler,
  clickHandler,
  email,
  password,
  loader,
  showMessage,
  alertMessage,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t, i18n } = useTranslation();
  const [isForgotPass, setIsForgotPass] = useState(false);
  const [lang, setLang] = useState("fa");
  const [showPassword, setShowPassword] = useState(false);

  const handleClickForgotPass = () => {
    setIsForgotPass(true);
  };

  function changeLanguage() {
    if (lang === "en") {
      setLang("fa");
    } else {
      setLang("en");
    }
    i18next.changeLanguage(lang === "en" ? "fa" : "en");
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="app-login-main-content">
      <div className="app-logo-content d-flex align-items-center justify-content-center">
        <span
          onClick={() => {
            window.location.replace("https://www.vkitaki.ir/fa/home");
          }}
          style={{
            position: " absolute",
            top: "25px",
            left: "35px",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          <span className="m-0 ">{t("sign_in.back_to_website")}</span>
          <ArrowBackIcon style={{ fontSize: "1.3rem" }} />
        </span>
        <div className="logo-lg">
          <SolarImage className="app-logo-content-logo" />
          <h1 className="bolder-text">{t("sign_in.to_world_wide")}</h1>
        </div>
      </div>

      <div className="app-login-content">
        <span onClick={() => changeLanguage()} className={classes.lang}>
          <span className={classes.title}>{t("sign_in.language")}</span>
          <BsGlobe2
            style={{ margin: "1px 5px", fontSize: "16px" }}
            fontSize={"small"}
          />
        </span>
        {isForgotPass ? (
          <ForgotPassOne
            isForgotPass={isForgotPass}
            setIsForgotPass={setIsForgotPass}
          />
        ) : (
          <>
            <div className="app-login-header mb-4">
              <h1>{t("sign_in.login_to_uptin")}</h1>
            </div>

            <div className="app-login-form">
              <form>
                <fieldset>
                  <span className={classes.inputRoot}>
                    <div className={classes.outlinedInput}>
                      <FormControl variant="outlined">
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          name="email"
                          onChange={changeHandler}
                          defaultValue={email}
                          startAdornment={
                            i18n.language === "fa" && (
                              <InputAdornment
                                position="start"
                                disablePointerEvents={true}
                              >
                                {t("sign_in.email")}
                              </InputAdornment>
                            )
                          }
                          endAdornment={
                            i18n.language === "en" && (
                              <InputAdornment
                                position="end"
                                disablePointerEvents={true}
                              >
                                {t("sign_in.email")}
                              </InputAdornment>
                            )
                          }
                        />
                      </FormControl>
                    </div>
                    <div className={classes.outlinedInput}>
                      <FormControl variant="outlined">
                        <OutlinedInput
                          dir="ltr"
                          type={showPassword ? "text" : "password"}
                          name="password"
                          id="outlined-adornment-weight"
                          onChange={changeHandler}
                          defaultValue={password}
                          endAdornment={
                            i18n.language === "fa" && (
                              <InputAdornment
                                position="start"
                                style={{ padding: "0 6px" }}
                              >
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                >
                                  {showPassword ? (
                                    <AiOutlineEye />
                                  ) : (
                                    <AiOutlineEyeInvisible />
                                  )}
                                </IconButton>
                                <p>{t("sign_up.password")}</p>
                              </InputAdornment>
                            )
                          }
                          startAdornment={
                            i18n.language === "en" && (
                              <InputAdornment position="start">
                                {t("sign_up.password")}
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                >
                                  {showPassword ? (
                                    <AiOutlineEye />
                                  ) : (
                                    <AiOutlineEyeInvisible />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            )
                          }
                        />
                      </FormControl>
                    </div>
                  </span>

                  <div className="mb-3 d-flex flex-column align-items-center justify-content-between">
                    <span className={classes.buttonRoot}>
                      <Button
                        className="btn btn-primary jr-btn-uptin"
                        onClick={clickHandler}
                        variant="contained"
                        disabled={!password || !email}
                      >
                        {loader ? (
                          <CircularProgress size={20} color="secondary" />
                        ) : (
                          t("sign_in.login")
                        )}
                      </Button>
                    </span>
                    <span className={classes.forgot_pass}>
                      {t("sign_in.don't_have_account")}
                      <Link to="/signup">
                        <span className={classes.forgot_blue}>
                          {t("sign_in.sign_up")}
                        </span>
                      </Link>
                    </span>
                    <div className={classes.forgot_pass}>
                      <p>
                        {t("sign_in.forgot_password")}{" "}
                        <span
                          className={classes.forgot_blue}
                          onClick={handleClickForgotPass}
                        >
                          {t("sign_in.forgot_password_2")}
                        </span>
                      </p>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </>
        )}
      </div>
      {showMessage &&
        enqueueSnackbar(alertMessage, {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
        })}
    </div>
  );
};

export default SignInPage;
